module.exports = __webpack_public_path__ + "img/26_19.c7371176.png";